import React from 'react';
import PageLoading from '../../pages/page-loading';

export default function asyncComponent(importComponent) {
  class AsyncComponent extends React.Component {
    constructor(props) {
      super(props);

      this.state = {
        component: null,
      };
    }

    async componentDidMount() {
      const { default: component } = await importComponent();

      this.setState({
        component,
      });
    }

    render() {
      const { component: C }: any = this.state;

      return C ? <C {...this.props} /> : <PageLoading />;
    }
  }

  return AsyncComponent;
}
